import { User } from 'oidc-client-ts';
import posthog from 'posthog-js';

import type { Middleware } from 'wg-api-sdk';

function getToken() {
  const oidcStorage = localStorage.getItem(
    `oidc.user:${import.meta.env.VITE_SSO_HOST}:${
      import.meta.env.VITE_SSO_CLIENT_ID
    }`,
  );

  if (!oidcStorage) return null;

  const user = User.fromStorageString(oidcStorage);

  return user.access_token;
}

export const getHeaders = (): Record<string, string> => {
  const token = getToken();

  const posthogSessionUrl = posthog.sessionRecordingStarted()
    ? posthog?.get_session_replay_url({ withTimestamp: true })
    : '';

  return {
    authorization: `Bearer ${token}`,
    'x-posthog': posthogSessionUrl,
  };
};

export const authMiddleware: Middleware = {
  onRequest({ request }) {
    const headers = getHeaders();

    for (const [header, value] of Object.entries(headers)) {
      if (value) request.headers.set(header, value);
    }

    return request;
  },
};
